<template>
  <!-- A fixed-size menu -->
  <!-- Parent must implement `updateSelectedItem(item)` -->
  <aside id="mainContent" v-bind:class="hideMenu ? 'hidden' : ''">
    <aside id="borderBlock">
      <div v-for="link in links" v-bind:key="link" v-bind:class="link.canonical === $route.name ? 'selected menuItem' : 'menuItem'" v-on:click="objectChange(link.canonical)">
        <!-- Simply loops on every item -->
        <!-- If the item matches current route it will receive the 'selected' class for a special formatting -->
        <div class="logoContainer">
          <div class="logoSizer">
            <svg
              v-if="link.canonical == 'About'"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="logo bi bi-person-lines-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"
              />
            </svg>
            <svg
              v-if="link.canonical == 'TranslationAssistant'"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="logo bi bi-translate"
              viewBox="0 0 16 16"
            >
              <path
                d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286H4.545zm1.634-.736L5.5 3.956h-.049l-.679 2.022H6.18z"
              />
              <path
                d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm7.138 9.995c.193.301.402.583.63.846-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6.066 6.066 0 0 1-.415-.492 1.988 1.988 0 0 1-.94.31z"
              />
            </svg>
            <svg
              v-if="link.canonical == 'WebExplorer'"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="logo bi bi-search"
              viewBox="0 0 16 16"
            >
              <path
                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
              />
            </svg>
            <svg
              v-if="link.canonical == 'Suggestions'"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="logo bi bi-envelope-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"
              />
            </svg>
            <svg
              v-if="link.canonical == 'Dictionaries'"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="logo bi bi-book-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"
              />
            </svg>
            <svg
              v-if="link.canonical == 'UnivTermino'"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="logo bi bi-book"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"
              />
            </svg>
          </div>
        </div>
        <div class="textContainer">
          <span>{{ link.name[lang] }}</span>
        </div>
      </div>
    </aside>
  </aside>
</template>

<script>
export default {
  name: "LeftMenu",
  props: {
    links: Array,
    lang: String,
    hideMenu: Boolean,
  },
  methods: {
    /**
     * Function triggered when an option is selected
     * in the menu
     *
     * @param item The canonical name of the selected item
     */
    objectChange(item) {
      // Notify parent
      this.$parent.changeLeftMenuState();
      this.$router.push({ name: item });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#mainContent {
  width: 17vw;
  height: 100%;
  position: fixed;
  z-index: 200;
  border-right: 1px solid #00214e;
}

#borderBlock {
  height: 84vh;
}

.menuItem {
  display: flex;
  height: 16.7%;
  overflow: hidden;
  cursor: pointer;
}

.textContainer {
  width: 100%;
  height: 30%;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  font-size: 150%;
  /* border : 1px solid salmon; */
}

.logoContainer {
  width: 40%;
  height: 100%;
  display: flex;
}

.logoSizer {
  width: 50%;
  height: 50%;
  margin : auto;
}

.logo {
  width: 100%;
  height: 100%;
  margin-top: auto;
}
.menuItem {
  background-color: rgba(255, 255, 255);
}

.menuItem .textContainer span {
  vertical-align: middle;
  color: #00214e;
}

.selected {
  background-color: #011633;
  color: rgba(255, 255, 255);
}

.selected .textContainer span {
  color: rgba(255, 255, 255);
}
.menuItem:hover {
  background-color: #011633;
  color: rgba(255, 255, 255);
}

.menuItem:hover span {
  color: rgba(255, 255, 255);
}

@media screen and (max-height: 900px) {
  .textContainer {
    font-size: 100%;
  }
}

/* Basic adjustments when screen is getting too small */
@media screen and (max-width: 850px) {
  #mainContent {
    border-right: none;
  }

  .menuItem {
    height: 20%;
  }
}

/* Classical phone display */
@media screen and (max-width: 850px) and (orientation: portrait){
  .textContainer {
    font-size: 100%;
  }

  #borderBlock {
    width: 80vw;
    height: 92vh;
  }

  .hidden {
    display: none;
  }
}

/* Horizontal phone display */
@media screen and (max-width: 850px) and (orientation: landscape){
  .textContainer {
    font-size: 100%;
  }

  #borderBlock {
    width: 45vw;
    height: 92vh;
  }

  .hidden {
    display: none;
  }
}
</style>
